/* sm-samband-sannprofun.js: sannprófun á hafa-samband forminu (forsíða og /pages/contact), 15.10.2026.
   Nafn, netfang og skilaboð eru skylda. Villuboð á íslensku undir reitnum (ekki stýrikerfisbóla á ensku),
   bendillinn fer í fyrsta reitinn sem vantar, og nafn með bara bilum telst tómt. Án JS gildir áfram
   required á reitunum. Hlustar í fanga-fasa svo sm-hafa-samband.js (skráarupphleðsla) fær ekki submit
   fyrr en formið er rétt. Villur frá Shopify (server) koma frá snippets/sm-samband-form.liquid við reitinn
   með aria-invalid; hér fer bendillinn í fyrsta slíka reitinn og villan hverfur þegar reiturinn er lagaður. */
(function () {
  'use strict';
  /* Enska (/en): textarnir koma úr JSON-blokk (script[data-sm-ord="samband"], aðeins utan aðaltungumáls); íslenskan er varagildið, svo íslensk hegðun er óbreytt. */
  var ORD = {};
  try { var oe = document.querySelector('script[data-sm-ord="samband"]'); if (oe) ORD = JSON.parse(oe.textContent) || {}; } catch (e) { ORD = {}; }
  function tx(k, fb, v) {
    var s = (typeof ORD[k] === 'string' && ORD[k]) ? ORD[k] : fb;
    if (v) { for (var n in v) { if (Object.prototype.hasOwnProperty.call(v, n)) s = s.split('{' + n + '}').join(v[n]); } }
    return s;
  }
  var forms = document.querySelectorAll('.sm-page-samband form.contact-form');
  if (!forms.length) return;

  var REGLUR = [
    { sel: '[name="contact[name]"]', tom: tx('villa_nafn', 'Skrifaðu nafnið þitt.') },
    { sel: '[name="contact[email]"]', tom: tx('villa_netfang_tomt', 'Skrifaðu netfangið þitt.'), rangt: tx('villa_netfang_rangt', 'Netfangið virðist ekki rétt. Dæmi: anna@email.is.'), epost: true },
    { sel: '[name="contact[body]"]', tom: tx('villa_skilabod', 'Skrifaðu okkur nokkur orð um verkefnið.') }
  ];
  var EPOST = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function villuEl(reitur) {
    var rot = reitur.closest('.form-field');
    var el = rot.querySelector('.form-villa');
    if (!el) {
      el = document.createElement('p');
      el.className = 'form-villa';
      el.id = 'villa-' + (reitur.name || 'reitur').replace(/[^a-z]/gi, '') + '-' + Math.floor(Math.random() * 1e5);
      el.hidden = true;
      rot.appendChild(el);
    }
    return el;
  }
  function hreinsa(reitur) {
    var el = reitur.closest('.form-field').querySelector('.form-villa');
    if (el) el.hidden = true;
    reitur.removeAttribute('aria-invalid');
    reitur.removeAttribute('aria-describedby');
  }
  function villa(reitur, texti) {
    var el = villuEl(reitur);
    el.textContent = texti;
    el.hidden = false;
    reitur.setAttribute('aria-invalid', 'true');
    reitur.setAttribute('aria-describedby', el.id);
  }
  function athuga(reitur, regla) {
    var gildi = (reitur.value || '').trim();
    if (!gildi) { villa(reitur, regla.tom); return false; }
    if (regla.epost && !EPOST.test(gildi)) { villa(reitur, regla.rangt); return false; }
    hreinsa(reitur);
    return true;
  }

  Array.prototype.forEach.call(forms, function (form) {
    form.setAttribute('novalidate', '');
    var reglur = REGLUR.map(function (r) { return { r: r, el: form.querySelector(r.sel) }; })
      .filter(function (x) { return x.el; });

    form.addEventListener('submit', function (e) {
      var fyrsti = null;
      reglur.forEach(function (x) { if (!athuga(x.el, x.r) && !fyrsti) fyrsti = x.el; });
      if (fyrsti) {
        e.preventDefault();
        e.stopImmediatePropagation();
        fyrsti.focus();
      }
    }, true);

    reglur.forEach(function (x) {
      x.el.addEventListener('input', function () { if (x.el.getAttribute('aria-invalid')) athuga(x.el, x.r); });
      x.el.addEventListener('blur', function () { if (x.el.getAttribute('aria-invalid')) athuga(x.el, x.r); });
    });

    var serverVilla = form.querySelector('[aria-invalid="true"]');
    if (serverVilla) serverVilla.focus();
  });
})();
